var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 80.525 80.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prescription",
    transform: "translate(0 -0.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7201",
    "data-name": "Path 7201",
    d: "M73.252.388A1.661,1.661,0,0,0,72.33.105H19.768c-4.519,0-8.2,3.932-8.2,8.751l-.309,48.89h-9.5A1.84,1.84,0,0,0,0,59.654v8.808c.006,6.468,4.859,11.709,10.847,11.717a1.656,1.656,0,0,0,.363-.04H55.064c.261.02.525.034.79.034,6.081-.012,11.006-5.338,11.008-11.907V39.685h11.9a1.84,1.84,0,0,0,1.765-1.906V9.478A9.045,9.045,0,0,0,73.252.388ZM3.53,68.462v-6.9H44.847v6.7a12.407,12.407,0,0,0,2.914,8.059H10.606a1.627,1.627,0,0,0-.248.021A7.685,7.685,0,0,1,3.53,68.462Zm59.8-58.984V68.265a8.4,8.4,0,0,1-2.181,5.682,7.149,7.149,0,0,1-5.057,2.407,1.631,1.631,0,0,0-.289-.028h-.621a7.938,7.938,0,0,1-6.808-8.059V59.654a1.84,1.84,0,0,0-1.765-1.906H14.794L15.1,8.87a4.819,4.819,0,0,1,4.665-4.952H65.085a9.581,9.581,0,0,0-1.753,5.559ZM76.995,35.872H66.862V9.478a5.076,5.076,0,1,1,10.133,0Zm0,0",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7202",
    "data-name": "Path 7202",
    d: "M120.293,92.254H138.35a1.906,1.906,0,0,0,0-3.813H120.293a1.906,1.906,0,1,0,0,3.813Zm0,0",
    transform: "translate(-98.053 -71.494)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7203",
    "data-name": "Path 7203",
    d: "M153.976,159.941H120.293a1.907,1.907,0,1,0,0,3.813h33.682a1.907,1.907,0,0,0,0-3.813Zm0,0",
    transform: "translate(-98.759 -129.363)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7204",
    "data-name": "Path 7204",
    d: "M153.976,231.438H120.293a1.906,1.906,0,1,0,0,3.813h33.682a1.906,1.906,0,1,0,0-3.813Zm0,0",
    transform: "translate(-98.759 -187.229)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/Prescription.881dd986c77e136a3a4c83bf3ce6c352.svg";
export { ForwardRef as ReactComponent };